import React from 'react';
import { useCart, useDispatchCart } from '../components/ContextReducer';
import { Trash } from 'react-bootstrap-icons';
import {BASE_URL} from './helper'

export default function Cart() {

    const data = useCart();
    const dispatch = useDispatchCart();

    if (data.length === 0) {
        return (
            <div>
                <div className='m-5 w-100 text-center fs-3' style={{ color: "black" }}> The Cart is Empty</div>
            </div>
        )
    }

    const handleCheckOut = async () => {
        let userEmail = localStorage.getItem("userEmail");
        // console.log(data,localStorage.getItem("userEmail"),new Date())
        let response = await fetch(`${BASE_URL}/api/orderdata`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            order_data: data,
            email: userEmail,
            order_date: new Date().toDateString()
          })
        });
        console.log("JSON RESPONSE:::::", response.status)
        if (response.status === 200) {
          dispatch({ type: "DROP" })
        }
    }


    const totalPrice = data.reduce((total, food) => total + food.price * food.qty, 0);

    const handleDecreaseQuantity = (index) => {
        dispatch({ type: "DECREASE_QUANTITY", index: index });
    };

    const handleIncreaseQuantity = (index) => {
        dispatch({ type: "INCREASE_QUANTITY", index: index });
    };

    return (
        <div>
            <div className='container m-auto mt-5 table-responsive table-responsive-lg table-responsive-sm table-responsive-md' style={{ color: "white" }}>
                <table className="table table-hover">
                    <thead className='text-success fs-4'>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Img</th>
                            <th scope="col">Name</th>
                            <th scope="col">Quantity</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Delet</th>
                        </tr>
                    </thead>
                    <tbody className='table-body'>
                        {data.map((food, index) => (
                            <tr key={index}>
                                <th scope="row">{index + 1}</th>
                                <td><img src={food.img} alt="" height="35px" /></td>
                                <td>{food.name}</td>
                                <td>
                                    <button className='plus-maines' onClick={() => handleDecreaseQuantity(index)}>-</button>
                                    {food.qty}kg
                                    <button className='plus-maines' onClick={() => handleIncreaseQuantity(index)}>+</button>
                                </td>
                                <td>{food.price * food.qty}</td>
                                <td>
                                    <button type="button" className="btn p-0" onClick={() => { dispatch({ type: "REMOVE", index: index }) }}>
                                        <Trash style={{}} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className='total-price'>
                    <h1 className='fs-2'>Total Price: {totalPrice}/-</h1>
                </div>
                <div>
                    <button className='btn bg-success mt-2' onClick={handleCheckOut}>Check Out</button>
                </div>
            </div>
        </div>
    )
}
